/**
* Adds a Confused.DomainProvider class to the Confused namespace. 
* Implemented as IIFE so we can pass in references to the global jQuery and window objects.
**/
(function (w) {

    "use strict";

    w.Confused = w.Confused || {};    

    /**
    * Helper for working with the current domain
    *
    * @Constructor
    */
    w.Confused.DomainProvider = function () {

        this.domainRegex = /^([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])(\.([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\-]{0,61}[a-zA-Z0-9]))*$/i;        
    };


    /**
    * Gets a domain for the hostname. e.g.
    * domainManager.getDomain(location)
    * This function will echo invalid domains. 
    *
    * @param {string} sKey. The name of the cookie.
    */
    w.Confused.DomainProvider.prototype.getDomain = function (location) {

        return location.hostname;
    };


    /**
    * Gets a domain for the hostname. e.g.
    * domainManager.getParentDomain(location)
    * This function will echo invalid domains. 
    *
    * @param {string} sKey. The name of the cookie.
    */
    w.Confused.DomainProvider.prototype.getParentDomain = function(location) {

        var parent = location.hostname;

        if (this.domainRegex.test(parent)) {

            var parts = parent.split(".");
            parts.shift();
            parent = parts.join(".");
        }

        return parent;
    };

}(window));